import Sortable from 'sortablejs';

/**
 * https://github.com/SortableJS/Sortable
 * 快捷指令在序列DOM上增加拖拽排序功能;
 * 使用方法: v-sort 或 v-sort:groupName="{confg}"
 * 配置参数如下:
 * 		group:string			组名/组配置对象(具体见github), 如果仅仅只配置组名, 可以使用v-sort:groupName快捷配置
 * 		draggable:string		可拖拽的列表项样式名称
 * 		handle:string			可拖拽的列表项中触发器样式名称
 * 		filter:string|function	不可拖拽的列表项样式名称或过滤函数
 * 		ghostClass:string		被拖拽的列表项在列表中对应的[占位列表项]的样式名称
 * 		dragClass:string		被拖拽的列表项的样式名称
 * 		...						支持所有SortableJs的options参数, 但是事件已经屏蔽, 需要单独使用VUE的@事件名方式配置;
 * 配置事件如下:
 * 		filter(e):		用来筛选可拖拽的DOM元素
 * 		choose(e):		DOM元素选中时触发
 * 		unchoose(e):	DOM元素取消选中时触发
 * 		start(e):		DOM元素开始拖拽时触发
 * 		end(e):			DOM元素完成拖拽时触发
 * 		add(e):			DOM元素从另一个列表拖拽到当前列表时触发
 * 		update(e):		DOM元素排序时触发
 * 		sort(e):		DOM元素在当前列表发生add/update/remove操作时触发
 * 		remove(e):		DOM元素从当前列表移除并添加到另一个列表时触发
 * 		move(e):		DOM元素在列表中拖拽时触发
 * 		clone(e):		DOM元素被拷贝时触发
 * 		change(e):		DOM元素在列表中的索引发生变更时触发
 */

export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		let conf = {};
		if (binding.arg) {
			(conf as any).group = binding.arg;
		}
		if (binding.value && Object.prototype.toString.call(binding.value) == '[object Object]') {
			for (let key in binding.value) {
				(conf as any)[key] = binding.value[key];
			}
		}

		const handler = vnode.componentInstance ? vnode.componentInstance.$listeners : (vnode.data || {}).on || {};
		(conf as any).onChoose = (e: any) => {
			handler.choose && handler.choose.fns && handler.choose.fns(e);
		};
		(conf as any).onUnchoose = (e: any) => {
			handler.unchoose && handler.unchoose.fns && handler.unchoose.fns(e);
		};
		(conf as any).onStart = (e: any) => {
			handler.start && handler.start.fns && handler.start.fns(e);
		};
		(conf as any).onEnd = (e: any) => {
			handler.end && handler.end.fns && handler.end.fns(e);
		};
		(conf as any).onAdd = (e: any) => {
			handler.add && handler.add.fns && handler.add.fns(e);
		};
		(conf as any).onUpdate = (e: any) => {
			handler.update && handler.update.fns && handler.update.fns(e);
		};
		(conf as any).onSort = (e: any) => {
			handler.sort && handler.sort.fns && handler.sort.fns(e);
		};
		(conf as any).onRemove = (e: any) => {
			handler.remove && handler.remove.fns && handler.remove.fns(e);
		};
		(conf as any).onFilter = (e: any) => {
			handler.filter && handler.filter.fns && handler.filter.fns(e);
		};
		(conf as any).onMove = (e: any) => {
			handler.move && handler.move.fns && handler.move.fns(e);
		};
		(conf as any).onClone = (e: any) => {
			handler.clone && handler.clone.fns && handler.clone.fns(e);
		};
		(conf as any).onChange = (e: any) => {
			handler.change && handler.change.fns && handler.change.fns(e);
		};

		(el as any)._sort = Sortable.create(el, conf);
	},
	inserted (el: HTMLElement, binding: any, vnode: any) {},
	update (el: HTMLElement, binding: any, vnode: any) {},
	componentUpdated (el: HTMLElement, binding: any, vnode: any) {},
	unbind (el: HTMLElement, binding: any, vnode: any) {
		(el as any)._sort.destroy();
	},
};
